import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t,
    language
  } = useLanguage();
  const isHebrew = language === 'he';
  return <footer className="text-white/80 py-8 mt-12 md:mt-20 bg-[#1B2A4A]" data-id="element-16">
      <div className="max-w-7xl mx-auto px-6 text-center" data-id="element-17">
        <p className="text-sm mb-2" data-id="element-18">{t.footer.copyright}</p>
        <p className="text-xs text-white/50" data-id="element-19">
          {isHebrew ? 'למידע על נגישות, אנא צרו איתנו קשר.' : 'For accessibility information, please contact us.'}
        </p>
      </div>
    </footer>;
}